import { SwitchProductModule } from '../switch-product.module';
export const useProductAvailability = _ref => {
  var _isSwitchFlowQuery$da, _currentProductQuery$, _currentProductQuery$2, _downgradeDetailsQuer, _isHasUpgradableCycle;
  let {
    productId
  } = _ref;
  const {
    isDowngradeEnabled,
    siteGuid
  } = SwitchProductModule.internals.useContext();
  const isSwitchFlowQuery = SwitchProductModule.SDK.switchApiClient.hooks.useIsSwitchFlow({});
  const isHasUpgradableCyclesQuery = SwitchProductModule.SDK.switchApiClient.hooks.useHasUpgradableCycles({
    productId
  });
  const currentProductQuery = SwitchProductModule.SDK.switchApiClient.hooks.useGetCurrentProduct({});
  const isSwitchFlow = (_isSwitchFlowQuery$da = isSwitchFlowQuery.data) == null ? void 0 : _isSwitchFlowQuery$da.isSwitchFlow;
  const shouldFetchDowngradeDetails = isSwitchFlow && isDowngradeEnabled && ((_currentProductQuery$ = currentProductQuery.data) == null || (_currentProductQuery$ = _currentProductQuery$.currentProduct) == null ? void 0 : _currentProductQuery$.subscriptionId) && siteGuid;
  const downgradeDetailsQuery = SwitchProductModule.SDK.switchApiClient.hooks.useGetDowngradeDetails({
    targetProductId: productId,
    existingSubscriptionId: ((_currentProductQuery$2 = currentProductQuery.data) == null || (_currentProductQuery$2 = _currentProductQuery$2.currentProduct) == null ? void 0 : _currentProductQuery$2.subscriptionId) ?? '',
    msid: siteGuid ?? ''
  }, !!shouldFetchDowngradeDetails, {
    refetchOnWindowFocus: false
  });
  const allQueries = [isSwitchFlowQuery, currentProductQuery, downgradeDetailsQuery, isHasUpgradableCyclesQuery];
  const isLoading = allQueries.some(q => q.isLoading);
  const isSuccess = allQueries.every(q => q.isSuccess);
  const canDowngrade = !!((_downgradeDetailsQuer = downgradeDetailsQuery.data) != null && _downgradeDetailsQuer.data);
  const canPurchase = !!((_isHasUpgradableCycle = isHasUpgradableCyclesQuery.data) != null && _isHasUpgradableCycle.hasUpgradableCycles);
  const isProductAvailable = canPurchase || canDowngrade;
  return {
    isSuccess,
    isLoading,
    canDowngrade,
    canPurchase,
    isProductAvailable
  };
};
//# sourceMappingURL=useProductAvailability.js.map